import React from "react";
import _ from "lodash";

import DesignList from "./DesignList";

const _renderDesigns = (list, _onItemClick) => {
  const { items: designs, loading, showSiteBlocks, showPageBlocks } = list;
  const selected = _.get(list, "selected");

  return (
    <DesignList
      loading={loading}
      selected={selected}
      onItemClick={_onItemClick}
      showSiteBlocks={showSiteBlocks}
      showPageBlocks={showPageBlocks}
      designs={designs}
    />
  );
};

const Navigator = ({ onSelectItem, list }) => {
  const _onItemClick = (item) => {
    onSelectItem(item);
  };

  const style = {
    position: "relative",
    height: "100%",
  };

  return (
    <div style={style} className="panel-scrolling-column design-list">
      {_renderDesigns(list, _onItemClick)}
    </div>
  );
};

export default Navigator;
